import { useEffect, useCallback } from 'react'

const PIXEL_ID = '754551913878347'

// Extend window type for fbq
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel if not already done
    if (typeof window !== 'undefined' && !window.fbq) {
      const f = window
      const b = document
      const e = 'script'

      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })

      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = 'https://connect.facebook.net/en_US/fbevents.js'

      const s = b.getElementsByTagName(e)[0]
      s?.parentNode?.insertBefore(t, s)

      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    }
  }, [])

  const trackCustomEvent = useCallback((eventName: string, params?: object) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', eventName, params)
    }
  }, [])

  const trackStandardEvent = useCallback(
    (eventName: string, params?: object) => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', eventName, params)
      }
    },
    [],
  )

  return { trackCustomEvent, trackStandardEvent }
}
